import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { dashboardRoutes } from "../routes/DashboardRoutes";

export const OnboardingStepGuard = ({ stepNumber, element }) => {
  const { user } = useAuth();
  const location = useLocation();
  const onboardingApplicationId = user?.data?.onboarding_application_id;

  // New OAuth users (Task 1/2) can have ONBOARDING status without a legacy
  // onboarding application. Keep them in the new register flow.
  if (!onboardingApplicationId) {
    return <Navigate to="/register" state={{ from: location }} replace />;
  }

  const currentStep = user?.data?.current_onboarding_step || 1;

  // Allow access only to current or completed steps
  if (stepNumber > currentStep) {
    // Redirect to current step while preserving intended location
    const onboardingRoute = dashboardRoutes.find(
      (r) => r.path === "/onboarding",
    );
    const stepPath = findStepPath(onboardingRoute?.routes || [], currentStep);
    return (
      <Navigate
        to={`/onboarding/${stepPath}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return element;
};

// Helper function to find a step's path by step number
export const findStepPath = (steps, stepNumber) => {
  const step = steps.find((s) => s.stepNumber === stepNumber);
  return step?.path || steps[steps.length - 1]?.path; // fallback to last route's path
};

// Component to redirect to the current onboarding step
export const NavigateToCurrentOnboardingStep = ({ onboardingRoutes }) => {
  const { user } = useAuth();
  const onboardingApplicationId = user?.data?.onboarding_application_id;

  if (!onboardingApplicationId) {
    return <Navigate to="/register" replace />;
  }

  const currentStep = user?.data?.current_onboarding_step || 1;
  const stepPath = findStepPath(onboardingRoutes, currentStep);

  return <Navigate to={`/onboarding/${stepPath}`} replace />;
};
